import { JSDOM } from "jsdom";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { GET_FAQ_ARTICLE } from "@api/queries/faq";
import { addApolloState, initializeApollo } from "@lib/apollo";
import PrivacyPolicy from "@modules/PrivacyPolicy/PrivacyPolicy";

export default function PrivacyPolicyPage(props) {
  return <PrivacyPolicy {...props} />;
}

export const getServerSideProps = async ({ locale }) => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: GET_FAQ_ARTICLE,
    variables: {
      lang: locale,
      id: "360013514799",
    },
  });

  if (!data?.article?.id) {
    return {
      redirect: {
        destination: `/${locale}`,
        permanent: true,
      },
    };
  }

  function replaceTags(htmlString) {
    const dom = new JSDOM(htmlString);
    const document = dom.window.document;

    const replaceTag = (oldTag, newTag) => {
      const elements = document.querySelectorAll(oldTag);
      elements.forEach((el) => {
        const newElement = document.createElement(newTag);

        while (el.firstChild) {
          newElement.appendChild(el.firstChild);
        }

        Array.from(el.attributes).forEach((attr) => {
          newElement.setAttribute(attr.name, attr.value);
        });
        el.replaceWith(newElement);
      });
    };

    replaceTag("h4", "h6");
    replaceTag("h3", "h5");
    replaceTag("h2", "h4");
    replaceTag("h1", "h3");

    return dom.serialize();
  }

  const props = addApolloState(apolloClient, {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      data: {
        article: {
          ...data.article,
          body: replaceTags(data.article.body),
        },
      },
    },
  });

  return props;
};
